import { styled } from 'styled-components'

import { Logo, LogoColor } from '../../components/svgs/Logo'
import { TopBarContainer, TopbarTitle } from '../../components/Topbar/TopbarTemplate'

const TopbarTitleContainer = styled.div`
  flex: 1;
`

export const LoginTopbar = () => {
  return (
    <TopBarContainer className="bg-neutral-800">
      <TopbarTitleContainer>
        <TopbarTitle>
          <Logo color={LogoColor.White} />
        </TopbarTitle>
      </TopbarTitleContainer>
    </TopBarContainer>
  )
}
